import React, { memo } from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ContentItem } from "../../constants/contentItems";
import BackgroundImage from "../../../../../../components/ui/BackgroundImage";
import CardHeading from "./CardHeading";

interface TallCardProps {
  item: ContentItem;
  onClick: () => void;
  fullscreenClick?: boolean;
}

const TallCard: React.FC<TallCardProps> = ({
  item,
  onClick,
  fullscreenClick,
}) => {
  const shouldReduceMotion = useReducedMotion();

  return (
    <motion.div
      className={`h-full ${fullscreenClick && "cursor-pointer"}`}
      whileHover={
        shouldReduceMotion
          ? undefined
          : { scale: 1.015, filter: "brightness(1.09)" }
      }
      whileTap={shouldReduceMotion ? undefined : { scale: 0.988 }}
      transition={{ duration: 0.25, ease: "easeOut" }}
      style={{ willChange: "transform" }}
      onClick={() => {
        if (fullscreenClick) {
          onClick();
        }
      }}
    >
      <BackgroundImage
        imageSrc={item.backgroundImageSrc + ""}
        imageClassName="!object-cover rounded-lg"
        className="h-full chakra-petch-font"
      >
        <div className={["grounded-lg overflow-hidden p-8 relative"].join(" ")}>
          {/* Hover edge glow — left accent line pulse */}
          {!shouldReduceMotion && (
            <motion.div
              aria-hidden
              className="absolute left-0 inset-y-0 w-[3px] rounded-l-lg pointer-events-none"
              style={{
                background:
                  "linear-gradient(180deg, #48A7FF, #ffffff33, #48A7FF)",
              }}
              initial={{ opacity: 0, scaleY: 0.4, originY: 0.5 }}
              whileHover={{
                opacity: 1,
                scaleY: 1,
                transition: { duration: 0.3, ease: "easeOut" },
              }}
            />
          )}

          {/* Content pinned top */}
          <div className="w-full h-full ">
            <CardHeading
              label={item.label}
              description={item.description}
              ctaText={item.ctaText}
              onCtaClick={onClick}
              cardButtonColors={{
                from: "#4f4e41",
                via: "#3a3930",
                to: "transparent",
              }}
            />
          </div>
        </div>
      </BackgroundImage>
    </motion.div>
  );
};

export default memo(TallCard);
